export const LIST_VIEW_SECTIONS = {
	PIPELINE: 'pipeline',
	CANDIDATES: 'candidates',
	JOBS: 'jobs',
	CLIENTS: 'clients',
	EXTERNAL_APPLICATIONS: 'external-applications'
};

export const SYSTEM_VIEW_KEYS = {
	PERSONALIZED: 'personalized',
	DEFAULT: 'default'
};

export const PERSONALIZED_VIEW_LABELS = {
	[LIST_VIEW_SECTIONS.PIPELINE]: 'My Pipeline',
	[LIST_VIEW_SECTIONS.CANDIDATES]: 'My Candidates',
	[LIST_VIEW_SECTIONS.JOBS]: 'My Jobs',
	[LIST_VIEW_SECTIONS.CLIENTS]: 'My Clients',
	[LIST_VIEW_SECTIONS.EXTERNAL_APPLICATIONS]: 'My External Applicants'
};
